/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 * Created Date: Sunday, 17th February 2019
 *
 * Address Form
 *
 * Fields:  Street Address, Address2, City, State,  Zip
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TextFieldWithValidation from 'components/InputFields/TextFieldWithValidation';

// Material UI Components
import Grid from '@material-ui/core/Grid';

const AddressFormReadOnly = props => {
  return props.visible !== false ? (
    <Grid container justify='center' className={props.classes.formGridContainer}>
      <Grid item xs={12}>
        <TextFieldWithValidation
          label='Street Address'
          type='text'
          visible
          value={props.address1}
          className={props.classes.address1}
          fullWidth
          readOnly
          autoComplete='off'
          InputProps={{
            disableUnderline: true,
            inputProps: {
              className: props.classes.input,
            },
          }}
          InputLabelProps={{
            className: props.classes.inputLabel,
          }}
        />
        <Grid item xs={12}>
          <Grid container>
            <Grid item sm={7} xs={12}>
              <TextFieldWithValidation
                type='text'
                visible
                message='City is a required field.'
                value={props.city}
                label='City'
                autoComplete='off'
                className={props.classes.addressCity}
                readOnly
                InputProps={{
                  disableUnderline: true,
                  inputProps: {
                    className: props.classes.input,
                  },
                }}
                InputLabelProps={{
                  className: props.classes.inputLabel,
                }}
              />
            </Grid>
            <Grid item sm={5} xs={11}>
              <Grid container>
                <Grid item sm={5} xs={3}>
                  <TextFieldWithValidation
                    type='text'
                    visible
                    label='State'
                    className={props.classes.addressState}
                    readOnly
                    autoComplete='off'
                    value={props.state}
                    InputProps={{
                      disableUnderline: true,
                      inputProps: {
                        className: props.classes.input,
                      },
                    }}
                    InputLabelProps={{
                      className: props.classes.inputLabel,
                    }}
                  />
                </Grid>
                <Grid item sm={7} xs={5}>
                  <TextFieldWithValidation
                    type='text'
                    visible
                    value={props.zip}
                    label='Zip'
                    autoComplete='off'
                    className={props.classes.addressZip}
                    readOnly
                    InputProps={{
                      disableUnderline: true,
                      inputProps: {
                        className: props.classes.input,
                      },
                    }}
                    InputLabelProps={{
                      className: props.classes.inputLabel,
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  ) : null;
};

AddressFormReadOnly.propTypes = {
  classes: PropTypes.object.isRequired,
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string,
  visible: PropTypes.bool,
};

const styles = theme => ({
  address1: {},
  address2: {},
  address3: {},
  addressCity: {},
  addressState: {},
  addressZip: {},
  input: {
    paddingTop: '1px',
    paddingRight: '3px',
    paddingleft: '3px',
    paddingBottom: '3px',
    fontSize: '10pt',
  },
  inputLabel: {
    fontSize: '11pt',
    [theme.breakpoints.down('xs')]: {
      fontSize: '10pt',
    },
    padding: '0 0 0 0 !important',
    margin: '0',
  },
  formGridContainer: {},
});

export default withStyles(styles, { withTheme: true })(AddressFormReadOnly);
